export interface GetStockListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetStockListPagingAndFilterResponseData
}

export interface GetStockListPagingAndFilterResponseData {
    items: GetStockListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetStockListPagingAndFilterResponseItem {
    stockId: string
    deviceBrandId: string
    deviceBrandName: string
    parentDeviceBrandId: string
    parentDeviceBrandName: string
    imei: string
    ccid: string
    plate: string
    phone: string
    isDemo: boolean
    softwareVersion: string
    macNumber: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    companyId: string
    companyName: string
    ioStatus?: boolean
    rfid?: boolean
    gpsDateTime?: string
    deviceNo: string
    isSelected: boolean
}

export const initialGetStockListPagingAndFilterResponseData: GetStockListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}